export const SPORTSBOOK_ANALYTICS_FILTER_KEYS = [
  "money_type",
  "bet_status",
  "bet_type",
  "sport",
  "league",
  "odds_provider",
  "state",
] as const;

export type SportsbookAnalyticsFilterKey =
  (typeof SPORTSBOOK_ANALYTICS_FILTER_KEYS)[number];

/** Shared filter metadata block emitted by sportsbook analytics endpoints in `meta.filters`. */
export type SportsbookAnalyticsFilterMetaDto = {
  key: string;
  multi_select: boolean;
  options: string[];
  default_values: string[];
  selected_values: string[];
};

/** Axios `params` keys expected by sportsbook analytics endpoints. */
export const SPORTSBOOK_ANALYTICS_FILTER_PARAM_KEYS: Record<
  SportsbookAnalyticsFilterKey,
  string
> = {
  money_type: "money_type[in]",
  bet_status: "bet_status[in]",
  bet_type: "bet_type[in]",
  sport: "sport[eq]",
  league: "league[eq]",
  odds_provider: "odds_provider[eq]",
  state: "state[eq]",
};

export type SportsbookAnalyticsHttpParams = Record<
  string,
  string | number | string[]
>;

const REPEATED_FILTER_KEYS = new Set<SportsbookAnalyticsFilterKey>([
  "money_type",
  "bet_status",
]);

export function buildSportsbookAnalyticsFilterParams(
  filters: Partial<Record<SportsbookAnalyticsFilterKey, string[] | undefined>>,
): SportsbookAnalyticsHttpParams {
  return SPORTSBOOK_ANALYTICS_FILTER_KEYS.reduce<SportsbookAnalyticsHttpParams>(
    (params, key) => {
      const values = filters[key];
      if (!values?.length) return params;

      params[SPORTSBOOK_ANALYTICS_FILTER_PARAM_KEYS[key]] =
        REPEATED_FILTER_KEYS.has(key) ? [...values] : values.join(",");
      return params;
    },
    {},
  );
}

export function serializeSportsbookAnalyticsParams(
  params: Record<string, unknown>,
): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];
    values.forEach((item) => searchParams.append(key, String(item)));
  });

  return searchParams.toString();
}

export const SPORTSBOOK_ANALYTICS_PARAMS_SERIALIZER = {
  serialize: serializeSportsbookAnalyticsParams,
};
